import React from "react";
import { MessageCircle } from "lucide-react";
import { waLink, WA_MESSAGES } from "@/lib/site";

/** Floating WhatsApp button — bottom-right, always available on public pages. */
export default function WhatsAppFab({ message = WA_MESSAGES.general }) {
  return (
    <a
      href={waLink(message)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed bottom-5 right-5 z-50 inline-flex items-center gap-2 rounded-full bg-[#25D366] hover:bg-[#1eb257] text-white px-4 py-3 shadow-lg shadow-emerald-500/30 transition-transform hover:-translate-y-0.5"
    >
      <MessageCircle className="h-5 w-5" strokeWidth={2.2} />
      <span className="hidden sm:inline text-sm font-semibold">WhatsApp us</span>
    </a>
  );
}

/** Inline WhatsApp CTA button for use inside sections. */
export function WhatsAppButton({ message, label = "Chat on WhatsApp", className = "", testid = "whatsapp-btn" }) {
  return (
    <a
      href={waLink(message)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className={`inline-flex items-center gap-2 rounded-md bg-[#25D366] hover:bg-[#1eb257] text-white px-4 py-2.5 text-sm font-semibold transition-colors ${className}`}
    >
      <MessageCircle className="h-4 w-4" /> {label}
    </a>
  );
}
